import { useCallback } from 'react';

import { fetchVacancyDetails } from '../../../services';
import { VacancyDetailsResponseInterface } from '../../../types/vacancies.types';
import { ApiServiceType, useApiService } from '../useApiService';

import { FetchVacancyHookType } from './useFetchVacancyDetails.types';

export const useFetchVacancyDetails: FetchVacancyHookType = ({ jobId, immediateExecute } = {}) => {
  const service: ApiServiceType<string, VacancyDetailsResponseInterface> = useCallback(
    ({ requestData, abortController } = {}) => fetchVacancyDetails(requestData, abortController),
    []
  );
  const serviceResult = useApiService<string, VacancyDetailsResponseInterface>({
    service,
    initialServiceRequestData: jobId,
    immediateExecute,
  });

  return {
    ...serviceResult,
    vacancyDetails: serviceResult.response,
    fetchVacancyDetails: serviceResult.executeCall,
  };
};
